export default function fetchWineCatalog(store) {
  // Attempt to load the Wine Catalog from the VueJS Rest Endpoint (/vuejs/vincreative/product-catalog)
  const uri = store.state.registry.getServiceEndpoint('datastore') + '/vuejs/vincreative/product-catalog'
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    redirect: 'follow',
    credentials: 'omit'
  }

  return fetch(uri, options)
    .then(resp => {
      if (resp.ok && resp.status) {
        return resp.json()
      }
      throw new Error('No REST Response or Invalid REST Response')
    })
}
